import { usePageDrawer } from '@app/components/page/drawer/PageDrawerContext';
import { useStreamSettingsStore } from '@app/modules/logger/screens/stream/stores/stream-screen-settings.store';
import { nlpIntegration } from '@mi-front/api-clients';
import { useCallback } from 'react';
import { usePostHogCaptureLiveTopics } from './usePostHogCaptureLiveTopics';

/**
 * Returns a function that opens the stream drawer with the Topic detail panel
 * and shows the given topic. Sets drawerData in stream settings then opens drawer.
 * Captures topic_detail_panel_opened for analytics when opened from popup.
 */
export function useOpenTopicDetailDrawer(): (topic: nlpIntegration.TopicOutDto) => void {
  const { openDrawer } = usePageDrawer();
  const updateSettings = useStreamSettingsStore((s) => s.updateSettings);
  const capture = usePostHogCaptureLiveTopics();

  return useCallback(
    (topic: nlpIntegration.TopicOutDto) => {
      capture('topic_detail_panel_opened', { source: 'popup', topic_id: topic.id });
      updateSettings({ drawerData: { topic } });
      openDrawer('live-topics-standalone');
    },
    [openDrawer, updateSettings, capture],
  );
}
